module.exports = __webpack_public_path__ + "static/professional-dog-trainer-apdt-b5ef0c9c762e69d0f380c517a7d79d00.png";